import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
     .shadow-section {
        width: 54px;
        background: transparent linear-gradient(90deg, #000000 0%, #00000000 100%) 0% 0% no-repeat padding-box;
        opacity: 0.54;
    }
    .sideBar-wrapper {
        height: 100%;
        background-color: #121214;
        border-right: 1px solid #212121;
        padding: 0.5rem 0px;

        a {
            text-decoration: none;
            color: #A8A8B1;
        }
        .sidebar-menu-dash {
            padding: 0.8rem 1.5rem;
            width: 100%;
            font-weight: bold;
        }
        .sidebar-menu {
            padding: 0.8rem 1.5rem;
            width: 100%;
            font-weight: bold;
            padding-left: 4rem;
        }
        .exchange-logo {
            margin-right: 0.25rem;
            width: 2rem;
        }
        .flex-menu {
            display: flex;
        }
        .exchange-name {
            font-size: 22px;
        }
        .exchange-no-name {
            height: 26px;
        }
        .active-exchange-menu,
        .active-menu {
            position: relative;
            background-color: rgb(58 79 255 / 15%);
            color: #ffffff;
        }
        .active-menu::before {
            content: "";
            width: 0;
            height: 100%;
            border-left: 2px solid #3a4fff;
            border-right: 2px solid #3a4fff;
            position: absolute;
            left: 0;
            top: 0;
        }
        .active-menu::after {
            content: "";
            width: 0;
            height: 0;
            border-top: 23px solid transparent;
            border-bottom: 23px solid transparent;
            border-left: 8px solid #3a4fff;
            position: absolute;
            left: 4px;
            top: 0;
        }
        .active-exchange-menu::before {
            content: "";
            width: 0;
            height: 60%;
            border-left: 2px solid #3a4fff;
            border-right: 2px solid #3a4fff;
            position: absolute;
            left: 0;
            top: 25%;
        }
        .active-exchange-menu::after {
            content: "";
            width: 0;
            height: 0;
            border-top: 23px solid transparent;
            border-bottom: 23px solid transparent;
            border-left: 8px solid #3a4fff;
            position: absolute;
            left: 4px;
            top: 25%;
        }
        .ant-badge-count {
            min-width: 0px;
            width: 13px;
            height: 13px;
            padding: 0px;
            line-height: 12px;
            font-size: 8px;
            background: #f83e18;
            -webkit-box-shadow: 0 0 0 1px #29292C;
            box-shadow: 0 0 0 1px #29292C;
            .current {
              color: #fff !important;
            }
        }
        .apply-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 2rem;
            .apply-btn {
                width: 100%;
            }
            .nav-icon {
                width: 1.4rem;
                margin-right: 0.5rem;
            }
        }
    }
    .less-content {
        align-items: flex-start;
        padding-top: 5rem;
        color: #A8A8B1;
        button {
            a {
                color:white;
            }
        }
    }
`;

export default Wrapper;